/** 샵관리 — 제품마스터 (매입단위 ↔ 사용단위 환산, 안전재고) */
import React from 'react';
import { hiCol } from 'components/grid/hiGrid';
import ShopGridPage from './ShopGridPage';
import { loadTable, persistTable, createUid, nextCode, num } from 'shop/shopStore';
import { kwField, ynField, matchKeyword, clearMod, dupErrors } from 'shop/shopPageHelpers';

const filter = (rows, v) =>
  rows.filter(
    (r) => r.mod !== 'D'
      && (!v.useYn || r.useYn === v.useYn)
      && matchKeyword(r, ['productCode', 'productNm', 'category'], v.keyword)
  );

const cfg = {
  gridId: 'sh-product',
  title: '제품마스터',
  uidKey: 'productUid',
  searchDefaults: { keyword: '', useYn: 'Y' },
  searchFields: () => [[kwField('코드·제품명·분류'), ynField()]],
  columns: () => [
    hiCol.edTextColumnForKey({ header: '제품코드', field: 'productCode', size: 110, required: true }),
    hiCol.edTextColumn({ header: '제품명', field: 'productNm', size: 200, required: true }),
    hiCol.edTextColumn({ header: '분류', field: 'category', size: 110 }),
    hiCol.edTextColumn({ header: '매입단위', field: 'buyUnit', size: 80, title: '거래처에서 사 오는 단위 (박스·병 등)' }),
    hiCol.edTextColumn({ header: '사용단위', field: 'useUnit', size: 80, title: '시술에 쓰고 출고하는 단위 (ml·개 등)' }),
    hiCol.edNumberColumn({ header: '환산수', field: 'unitRatio', size: 80, title: '1 매입단위 = N 사용단위' }),
    hiCol.edNumberColumn({ header: '기본단가', field: 'baseCost', size: 100, title: '사용단위당 참고단가 (재고가 없을 때 원가 미리보기용)' }),
    hiCol.edNumberColumn({ header: '안전재고', field: 'safetyQty', size: 90, title: '사용단위 기준. 미달 시 재고현황에 표시' }),
    hiCol.edCheckboxColumn({ header: '사용', field: 'useYn', size: 72 }),
    hiCol.edTextColumn({ header: '비고', field: 'remark', size: 160 }),
  ],
  load: (tc) => clearMod(loadTable(tc, 'product')),
  filter,
  emptyRow: (rows) => ({
    productUid: createUid('PRD'),
    productCode: nextCode(rows, 'productCode', 'P'),
    productNm: '',
    category: '',
    buyUnit: '박스',
    useUnit: '개',
    unitRatio: 1,
    baseCost: 0,
    safetyQty: 0,
    useYn: 'Y',
    remark: '',
  }),
  validate: (rows, tc) => {
    const errors = dupErrors(rows, 'productCode', '제품코드');
    const usedLots = new Set(loadTable(tc, 'stockIn').map((l) => l.productUid));
    const usedBom = new Set(loadTable(tc, 'serviceItem').map((i) => i.productUid));
    for (const r of rows) {
      if (r.mod === 'D') {
        if (usedLots.has(r.productUid) || usedBom.has(r.productUid)) {
          errors.push(`입고·서비스에서 사용 중인 제품은 삭제할 수 없습니다(사용=N 처리): ${r.productNm}`);
        }
        continue;
      }
      if (!String(r.productCode || '').trim()) errors.push('제품코드는 필수입니다.');
      if (!String(r.productNm || '').trim()) errors.push(`제품명 누락 (${r.productCode})`);
      if (num(r.unitRatio) <= 0) errors.push(`환산수는 0보다 커야 합니다 (${r.productCode})`);
    }
    return errors;
  },
  save: (tc, rows, v) => {
    persistTable(tc, 'product', 'productUid', rows, (r) => filter([r], v).length > 0, (r) => ({
      ...r,
      productCode: String(r.productCode).trim(),
      productNm: String(r.productNm).trim(),
      unitRatio: num(r.unitRatio) || 1,
      baseCost: num(r.baseCost),
      safetyQty: num(r.safetyQty),
      useYn: r.useYn === 'N' ? 'N' : 'Y',
    }));
  },
};

const ProductMaster = () => <ShopGridPage cfg={cfg} />;
export default ProductMaster;
